let _ = t => t,
  _t;
import styled from 'styled-components';
import { ArrowUpRight } from '@ovpn-ui/icons';
import { matchLinkStyles } from '../_internal/components/Links';
export const Anchor = styled.a(({
  variant
}) => matchLinkStyles(variant));
export const ExternalIcon = styled(ArrowUpRight)(_t || (_t = _`
    margin-top: -1px;
`));